(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hh-styles"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(){
      if(!('IntersectionObserver' in window)) return;
      var els=document.querySelectorAll('.hh-reveal');
      els.forEach(function(e){ if(!e.classList.contains('hh-seen')) e.classList.add('hh-pre'); });
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.remove('hh-pre'); e.target.classList.add('hh-seen'); io.unobserve(e.target); } })},{threshold:.12});
      els.forEach(function(e){ if(!e.classList.contains('hh-seen')) io.observe(e); });
    }
    if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
